import React, {Component} from 'react';
import PropTypes from "prop-types";
import StaticFunctions from "./StaticFunctions";
import moment from "moment/moment";
import domtoimage from "dom-to-image";
import fileDownload from "js-file-download";
import jquery from "jquery";

class DOMDownloadButton extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        domId: PropTypes.string.isRequired,
    };

    static defaultProps = {
        fileName: 'download',
        label: null
    };

    constructor(props) {

        super(props);

        this.state = {
            domObj: null
        };

        this.translate = this.props.baseData.translate;
        this.fileName = this.props.fileName.replace('.pdf', '');
        this.label = (this.props.label) ? this.props.label : this.translate('imageDownloadLabel') + ' (PNG)';

        this.setDomObj = this.setDomObj.bind(this);
        this.getDomArea = this.getDomArea.bind(this);
        this.downloadDom = this.downloadDom.bind(this);

    }

    componentWillMount() {

        this.setDomObj();

    }

    componentWillReceiveProps(nextProps) {

        this.setDomObj();

    }

    setDomObj() {

        const domObj = jquery('#' + this.props.domId);

        if (domObj) {
            this.setState({
                domObj: domObj[0]
            });
        }

    }

    getDomArea() {

        //const domArea = document.getElementById(this.props.domId);
        const domArea = jquery('#' + this.props.domId);

        //if (domArea) return domArea;
        if (domArea) return domArea[0];

        return null;

    }

    downloadDom() {

        const domObj = this.state.domObj;

        if (domObj) {
            const fileName = StaticFunctions.getDownloadFilename(new moment(), this.fileName) + '.png';

            domtoimage.toBlob(domObj, {bgcolor: '#ffffff'}).then(function (blob) {
                fileDownload(blob, fileName);
            }).catch(function() {
                console.debug("DOM TO IMG Failure", arguments);
            });
        }

    }

    render() {

        if (!this.state.domObj) {
            return (
                <div className="bottomLinks clearfix">
                    <div><button className="disabled-link">{this.translate('imageDownloadLabel') + ' (PNG)'}</button></div>
                </div>
            );
        }

        const label = this.label;

        return (
            <div>
                <button onClick={this.downloadDom}>{label}</button>
            </div>
        );

    }

}

export default DOMDownloadButton;